import { Icon, Panel, Typography } from "matsuri-ui"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { useCleaningDetail } from "./providers/cleaningDetail"
import { TakePhotoIcon } from "@/components/Icon/TakePhotoIcon"
import { genCleaningInfoPagePath } from "@/routes/protected"

interface ErrandContent {
    id: string
    title: string
    description: string
    cleaningId: string
    pictures: string[]
    solved?: boolean
}

type Errand = Record<string, ErrandContent>

const ErrandList = (props: { errand: Errand; cleaningId: string }) => {
    const errands = useMemo(
        () =>
            Object.entries(props.errand)
                .map(([key, val]) => ({
                    ...val,
                    solved: val.pictures.length > 0
                }))
                .sort(p => (p.solved ? 1 : -1)),
        [props.errand]
    )

    return (
        <>
            {errands.map(val => {
                const InnerComponent = (
                    <Panel
                        key={val.id}
                        disabled={val.solved}
                        icon={
                            val.solved ? (
                                <Icon.Check
                                    color={"primary"}
                                    style={{ fontSize: "40px" }}
                                />
                            ) : (
                                <TakePhotoIcon />
                            )
                        }
                    >
                        <Typography color={"inherit"}>{val.title}</Typography>
                    </Panel>
                )

                return val.solved ? (
                    InnerComponent
                ) : (
                    <Link
                        to={genCleaningInfoPagePath(
                            props.cleaningId,
                            `errand/take-photo/${val.id}`
                        )}
                        key={val.id}
                        style={{ color: "initial" }}
                    >
                        {InnerComponent}
                    </Link>
                )
            })}
        </>
    )
}

export const ErrandPage = () => {
    const { detail } = useCleaningDetail()

    const errand = useMemo(() => {
        return (detail?.errands ?? []).reduce(
            (prev, curr) => ({ ...prev, [curr.id]: curr }),
            {}
        )
    }, [detail])

    return detail ? <ErrandList errand={errand} cleaningId={detail.id} /> : null
}
